/* unplugin-vue-components disabled */import script from "./AliMiniGame.vue?vue&type=script&setup=true&lang=ts"
export * from "./AliMiniGame.vue?vue&type=script&setup=true&lang=ts"

import "./AliMiniGame.vue?vue&type=style&index=0&id=c6f992f8&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6f992f8"]])

export default __exports__